<template>
    <div class="login-page">
        <div class="login-bg"></div>
        <div class="login-content">
            <div class="login-header">
                <img class="login-logo" src="../assets/favicon.png" />
                <div class="login-title">凌丰供应商系统</div>
                <div class="login-subtitle">LINKFAIR SUPPLIER MANAGEMENT SYSTEM</div>
            </div>
            <div class="login-card">
                <div class="card-header">
                    <i class="el-icon-user-circle"></i>
                    <span>用户登录</span>
                </div>
                <el-form ref="loginForm" :rules="rules" :model="loginForm" class="login-form" size="medium">
                    <el-form-item prop="userName" label="用户名" label-width="80px">
                        <el-input type="text" v-model="loginForm.userName" placeholder="请输入用户名" style="width: 78%;"
                            @keyup.enter.native="loginSubmit" prefix-icon="el-icon-user">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" label="密码" label-width="80px">
                        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" style="width: 78%;"
                            @keyup.enter.native="loginSubmit" prefix-icon="el-icon-lock">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="companyId" label="需方组织" label-width="80px">
                        <el-select v-model="loginForm.companyId" placeholder="请选择需方组织" prefix-icon="el-icon-lock"
                            style="width: 78%;" @change="changeCompanyId">
                            <el-option label="广东凌丰五金装备科技股份有限公司" value="LFWZ"></el-option>
                            <el-option label="南通立德装备科技有限公司" value="NTLD"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-row :gutter="12">
                            <el-col :span="12">
                                <el-button class="btn-login" @click="loginSubmit" type="primary">登录</el-button>
                            </el-col>
                            <el-col :span="12">
                                <el-button class="btn-reset" @click="loginReset">重置</el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
            <div class="login-footer">
                <span>© 2024 LINKFAIRTECH 版权所有</span>
            </div>
        </div>
    </div>
</template>

<script>
import * as baseApi from '@/Api/baseApi'
export default {
    name: "login",
    data() {
        return {
            loginForm: {
                userName: "",
                password: "",
                companyId: localStorage.getItem("companyId") ? localStorage.getItem("companyId") : "",
            },
            rules: {
                userName: [{ required: true, message: '请输入用户名', trigger: 'change' }],
                password: [{ required: true, message: '请输入密码', trigger: 'change' }],
                companyId: [{ required: true, message: '请选择需方组织', trigger: 'change' }],
            }
        }
    },
    methods: {
        changeCompanyId() {
            localStorage.setItem("companyId", this.loginForm.companyId)
            this.$store.commit('SET_COMPANY_ID', this.loginForm.companyId)
        },
        async loginSubmit() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    baseApi.loginApi(this.loginForm, this).then(res => {
                        sessionStorage.setItem("userName", res.userName)
                        sessionStorage.setItem("token", res.token)
                        sessionStorage.setItem("roleName", res.roleName)
                        this.$message({ type: 'success', message: '登录成功' })
                        this.$router.push('/')
                    }).catch(() => { })
                }
            })
        },
        loginReset() {
            this.$refs.loginForm.resetFields();
        }
    },
    mounted() {

    },
    created() {

    }
}
</script>

<style scoped>
.login-page {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #12b4bd 0%, #0e8f96 50%, #0d7a80 100%);
    opacity: 0.9;
}

.login-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
}

.login-header {
    text-align: center;
    margin-bottom: 40px;
}

.login-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
    animation: float 3s ease-in-out infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

.login-title {
    font-size: 36px;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    margin-bottom: 8px;
}

.login-subtitle {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    letter-spacing: 3px;
}

.login-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    width: 450px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
}

.card-header i {
    font-size: 32px;
    color: #12b4bd;
}

.card-header span {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
}

.login-form {
    margin-bottom: 0;
}

.login-form ::v-deep .el-form-item {
    margin-bottom: 24px;
}

.login-form ::v-deep .el-form-item__content {
    margin-left: 0 !important;
}

.login-form ::v-deep .el-input__inner {
    height: 44px;
    font-size: 15px;
}

.btn-login {
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
}

.btn-reset {
    width: 100%;
    height: 44px;
    font-size: 16px;
    border-radius: 8px;
}

.login-footer {
    margin-top: 30px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
}
</style>